
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
// import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './lib/auth'
import { InstallBanner } from './components/InstallBanner'

// Component that preserves URL hash when redirecting to login
// This is needed for Supabase invite/recovery flows where tokens are in the hash
function RedirectToLogin() {
  const location = useLocation()
  const hash = location.hash || window.location.hash

  // If there's a hash with auth tokens, preserve it
  if (hash && (hash.includes('type=invite') || hash.includes('type=recovery') || hash.includes('access_token'))) {
    // Redirect to /login with hash preserved
    window.location.href = '/login' + hash
    return null
  }

  return <Navigate to="/login" replace />
}
import { ProtectedRoute } from './components/ProtectedRoute'
import { Layout } from './components/Layout'
import { Login } from './pages/Login'
import { SubcontractorDashboard } from './pages/subcontractor/Dashboard'
import { MyProfile } from './pages/subcontractor/MyProfile'
import { AdminCustomers } from './pages/admin/Customers'
import { CustomerDetail } from './pages/admin/CustomerDetail'
import { AdminSubcontractors } from './pages/admin/Subcontractors'
import { SubcontractorDetail } from './pages/admin/SubcontractorDetail'
import { AdminArticles } from './pages/admin/Articles'
import { ArticleDetail } from './pages/admin/ArticleDetail'
import { ArticleCategories } from './pages/admin/ArticleCategories'
import { PriceLists } from './pages/admin/PriceLists'
import { PriceListDetail } from './pages/admin/PriceListDetail'
import { AdminAssignments } from './pages/admin/Assignments'
import { AssignmentDetail } from './pages/admin/AssignmentDetail'
import { BulkCreateAssignments } from './pages/admin/BulkCreateAssignments'
import { SubcontractorAssignments } from './pages/subcontractor/Assignments'
import { SubcontractorAssignmentDetail } from './pages/subcontractor/AssignmentDetail'
import { SubcontractorCalendar } from './pages/subcontractor/Calendar'
import { AdminCommunications } from './pages/admin/Communications'
import { Planning } from './pages/admin/Planning'
import { SubcontractorArticles } from './pages/subcontractor/Articles'
import { SubcontractorHandbook } from './pages/subcontractor/Handbook'
import { AdminTGInfo } from './pages/admin/TGInfo'
import { AdminTGActivity } from './pages/admin/TGActivity'
import { Provisions } from './pages/admin/Provisions'
import { WeeklySummary } from './pages/admin/WeeklySummary'
import { DrivingLog } from './pages/admin/DrivingLog'
import { Statistics } from './pages/admin/Statistics'

function App() {
  return (
    <AuthProvider>
      {/* <Toaster position="top-right" /> */}
      <InstallBanner />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Admin routes */}
        <Route path="/admin" element={
          <ProtectedRoute requiredRole="admin">
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/admin/assignments" replace />} />
          <Route path="customers" element={<AdminCustomers />} />
          <Route path="customers/:id" element={<CustomerDetail />} />
          <Route path="subcontractors" element={<AdminSubcontractors />} />
          <Route path="subcontractors/:id" element={<SubcontractorDetail />} />
          <Route path="articles" element={<AdminArticles />} />
          <Route path="articles/categories" element={<ArticleCategories />} />
          <Route path="articles/:id" element={<ArticleDetail />} />
          <Route path="pricelists" element={<PriceLists />} />
          <Route path="pricelists/:id" element={<PriceListDetail />} />
          <Route path="assignments" element={<AdminAssignments />} />
          <Route path="assignments/bulk-create" element={<BulkCreateAssignments />} />
          <Route path="assignments/:id" element={<AssignmentDetail />} />
          <Route path="planning" element={<Planning />} />
          <Route path="communications" element={<AdminCommunications />} />
          <Route path="weekly-summary" element={<WeeklySummary />} />
          <Route path="provisions" element={<Provisions />} />
          <Route path="information" element={<AdminTGInfo />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="driving-log" element={<DrivingLog />} />
          <Route path="activity" element={<AdminTGActivity />} />
        </Route>
        
        {/* Subcontractor routes */}
        <Route path="/subcontractor" element={
          <ProtectedRoute requiredRole="subcontractor">
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<SubcontractorDashboard />} />
          <Route path="calendar" element={<SubcontractorCalendar />} />
          <Route path="assignments" element={<SubcontractorAssignments />} />
          <Route path="assignments/:id" element={<SubcontractorAssignmentDetail />} />
          <Route path="articles" element={<SubcontractorArticles />} />
          <Route path="handbook" element={<SubcontractorHandbook />} />
          <Route path="profile" element={<MyProfile />} />
        </Route>
        
        {/* Default redirect - uses RedirectToLogin to preserve auth hash */}
        <Route path="/" element={<RedirectToLogin />} />
        <Route path="*" element={<RedirectToLogin />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
